module.exports = __webpack_public_path__ + "../assets/img/de296894d6eefa193677f4b109db6565.svg";